export default __webpack_public_path__ + "static/media/abstract-frame.6553662e.svg";